class AppUpdateModal extends HTMLElement {
  constructor() {
    super();
  }

  detectWebview() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iOS WebView Detection
    const isIOS = /iPhone|iPod|iPad/.test(userAgent);
    const isSafari =
      /Safari/.test(userAgent) || /CriOS|FxiOS|EdgiOS/.test(userAgent); // Exclude Chrome, Firefox, Edge
    const isIOSWebView =
      isIOS &&
      !isSafari &&
      (navigator.standalone === false || /AppleWebKit/.test(userAgent));

    // Android WebView Detection
    const isAndroid = /Android/.test(userAgent);
    const isAndroidWebView =
      (isAndroid && /wv/.test(userAgent)) ||
      (isAndroid &&
        /Version\/\d+\.\d+/.test(userAgent) &&
        !/Chrome/.test(userAgent));

    // React Native WebView Detection
    const isReactNativeWebView = !!window.ReactNativeWebView;

    return {
      isWebView: isIOSWebView || isAndroidWebView || isReactNativeWebView,
      platform: isIOSWebView ? "ios" : isAndroidWebView ? "android" : "web",
    };
  }

  showModal() {
    const result = this.detectWebview();
    if (result.isWebView && result.platform === "ios") {
      const updateLink =
        result.platform === "ios"
          ? "https://itunes.apple.com/us/app/cure-fit/id1217794588"
          : "https://play.google.com/store/apps/details?id=fit.cure.android";

      // Disable page scroll
      document.body.classList.add("app-no-scroll");

      this.innerHTML = `
        <div class="app-update-modal-overlay"></div>
        <div class="app-update-modal">
          <img src="${this.getAttribute("icon")}" alt="Cultstore Icon" class="app-update-icon">
          <p class="app-update-message">A new version of the app is available.<br>Please update to continue.</p>
          <a href="${updateLink}" class="app-update-button">Update Now</a>
        </div>
      `;
    }
  }
}

customElements.define("app-update-modal", AppUpdateModal);
